import {
  CreateServiceWorkInstructionCommand,
  FinishWorkInstructionJobCommand,
  WorkInstructionDto,
  WorkInstructionsApi,
} from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'
import { BaseEntityStore } from './base/BaseEntityStore'

export class WorkInstructionStore extends BaseEntityStore<WorkInstructionDto> {
  async load(vesselId?: number) {
    const { data } = await createApiClient(WorkInstructionsApi).get(vesselId)
    this.updateStoreItems(data)
  }

  async loadWorkInstructionsByIds(ids: number[]) {
    const { data } = await createApiClient(WorkInstructionsApi).getWorkInstructionsByIds(ids)
    this.updateAndReplaceItems(data)
  }

  async loadWorkInstructionsByCarrierVisitIdAndWorkQueueId(
    vesselId?: number,
    workQueueId?: number,
  ) {
    const { data } = await createApiClient(WorkInstructionsApi).get(
      vesselId,
      undefined,
      workQueueId,
    )
    this.updateAndReplaceItems(data)
  }

  async loadWorkInstructionsAsJobs() {
    const { data } = await createApiClient(WorkInstructionsApi).getWorkInsturctionsAsJobs()

    return data
  }

  async getRailcarTrackPositions(railVisitId?: number) {
    const { data } =
      await createApiClient(WorkInstructionsApi).railcarTrackPositionsByRailVisitId(railVisitId)

    return data
  }

  async create(instruction: CreateServiceWorkInstructionCommand) {
    await createApiClient(WorkInstructionsApi).create(instruction)
  }

  async finishJob(finishJobCommand: FinishWorkInstructionJobCommand) {
    await createApiClient(WorkInstructionsApi).finishWorkInstructionJob(finishJobCommand)
  }
}
